import { useState, useEffect } from 'react';
import api from './api';

// /users/active の取得フック。複数コンポーネントから利用される共通化用途。
// キャッシュは持たない: モジュールスコープで保持するとユーザー切替時にテナント間で
// データ漏洩する恐れがあるため、mount 単位で都度取得する設計とする。
// 取得サイズは通常テナント内ユーザー数（〜100件）で軽量。
export function useActiveUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const res = await api.fetch('/users/active');
                if (!res || !res.ok) return;
                const data = await res.json();
                if (mounted && Array.isArray(data)) setUsers(data);
            } catch (err) {
                console.error('Failed to fetch active users:', err?.message);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, []);

    return { users, loading };
}
